export default "__VITE_ASSET__6dy1epga__"